import { useState, useEffect } from 'react';

// =====================================================================
// "A tela é de celular?" — um lugar só para a pergunta.
//
// ⚠️ O portal já responde isso em ~151 pontos, cada um com o seu
//    `useState(window.innerWidth <= 768)` + listener de resize. Este hook não
//    migra os existentes (seria varredura grande e arriscada em telas que
//    funcionam); ele existe para o código NOVO parar de multiplicar a cópia — e
//    para o dia em que o ponto de corte mudar não virar caça a 151 lugares.
//
// ⚠️ O corte de 768px é o MESMO que a Sidebar e os hubs já usam. Escolher outro
//    número aqui faria o menu recolher num ponto e a tabela virar cartão noutro,
//    com uma faixa de larguras em que a tela fica meio de cada jeito.
// =====================================================================

export const CORTE_MOBILE = 768;
/** Tablet em pé também precisa de layout enxuto, mas cabe mais que um celular. */
export const CORTE_TABLET = 1024;

/**
 * @returns {{ehMobile: boolean, ehTabletOuMenor: boolean, largura: number}}
 */
export default function useTelaMobile() {
    const [largura, setLargura] = useState(
        // ⚠️ Guarda para ambiente sem `window` (o Jest do backend carrega arquivos
        //    do front no teste de espelho). Sem isto, importar este hook lá quebra.
        typeof window === 'undefined' ? 1280 : window.innerWidth
    );

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;
        const aoRedimensionar = () => setLargura(window.innerWidth);
        window.addEventListener('resize', aoRedimensionar);
        // Mede uma vez na montagem: entre o `useState` inicial e o efeito, a
        // largura pode ter mudado (rotação de tela, teclado abrindo).
        aoRedimensionar();
        return () => window.removeEventListener('resize', aoRedimensionar);
    }, []);

    return {
        ehMobile: largura <= CORTE_MOBILE,
        ehTabletOuMenor: largura <= CORTE_TABLET,
        largura,
    };
}
